import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { initializeApiClient } from './api/api-config';
import { reloadForStaleChunk } from './utils/staleChunkReload';

// A deploy replaces the content-hashed JS/CSS chunks, so users mid-session
// fail to lazy-load screens they haven't visited yet. Vite emits this event
// on any dynamic-import/preload failure; reload once to fetch the new build
// instead of letting the error hit the error boundary.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForStaleChunk()) {
    event.preventDefault();
  }
});

// Initialize API client with configuration
initializeApiClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
